import React from 'react'
import QuestionsList from './QuestionsList'
import EditQuestionForm from './EditQuestionForm'
import EditQuestionActions from './EditQuestionActions'
import EditAnswerForm from './EditAnswerForm'
import AnswersList from './AnswersList'
import { Button, Modal, Tab } from 'semantic-ui-react'
import fixModalStyle from '../utils/fixModalStyle'

export default ({ provider, editQuestion, questionAnswers, editAnswer, onMount, onNewClick, onEditClick, onDeleteClick, onCancelEdit, onSaveQuestion, onSaveAnswer, onSaveAnswers, onCancelEditAnswers, onEditAnswer, onDeleteAnswer, onCancelEditAnswer }) => {
    return <div>
        <Modal style={fixModalStyle} open={!!editQuestion}>
            <Modal.Content>
                <Tab panes={[
                        { 
                            menuItem: 'Domanda', 
                            render: () => <Tab.Pane><EditQuestionForm 
                                    question={editQuestion} 
                                    onSubmit={onSaveQuestion}
                                    onCancelEdit={onCancelEdit}
                                    />
                                </Tab.Pane>},
                        { 
                            menuItem: 'Risposte', 
                            render: () => <Tab.Pane>
                                    <EditAnswerForm 
                                        answer={editAnswer} 
                                        onSubmit={answer => onSaveAnswer({ ...answer, question_id: editQuestion.id })}
                                        onCancel={onCancelEditAnswer} />
                                    <AnswersList 
                                        answers={questionAnswers} 
                                        selectedAnswer={editAnswer} 
                                        onSaveAnswer ={onSaveAnswer}
                                        onEdit={onEditAnswer} 
                                        onDelete={onDeleteAnswer} />
                                    <Button onClick={onCancelEditAnswers}>Chiudi</Button>
                                </Tab.Pane>}
                    ]} />
            </Modal.Content>
        </Modal>
        <div>
            <Button primary onClick={onNewClick}>Nuova domanda...</Button>
        </div>
        <QuestionsList 
            provider={provider}
            onMount={onMount} 
            actions={EditQuestionActions} 
            actionsCallbacks={{ onEditClick, onDeleteClick }} 
            disableOrder = {true}/>
    </div>
}


// WEBPACK FOOTER //
// ./src/components/QuestionsPage.js